var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43384"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C0DAFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "posponed",
    d: "M20.2008 16.7646V22.1572M20.2008 25.3928H20.2116M14.8082 10.2935V12.4505M25.5934 10.2935V12.4505M13.9454 29.7069H26.4563C27.6643 29.7069 28.2684 29.7069 28.7298 29.4717C29.1356 29.265 29.4657 28.935 29.6724 28.5291C29.9075 28.0677 29.9075 27.4636 29.9075 26.2556V15.9018C29.9075 14.6937 29.9075 14.0897 29.6724 13.6283C29.4657 13.2224 29.1356 12.8924 28.7298 12.6856C28.2684 12.4505 27.6643 12.4505 26.4563 12.4505H13.9454C12.7374 12.4505 12.1333 12.4505 11.6719 12.6856C11.266 12.8924 10.936 13.2224 10.7292 13.6283C10.4941 14.0897 10.4941 14.6937 10.4941 15.9018V26.2556C10.4941 27.4636 10.4941 28.0677 10.7292 28.5291C10.936 28.935 11.266 29.265 11.6719 29.4717C12.1333 29.7069 12.7373 29.7069 13.9454 29.7069Z",
    stroke: "#0049A6",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard6);
export default __webpack_public_path__ + "static/media/Card6.826ed406c5c626859332b28bb156560c.svg";
export { ForwardRef as ReactComponent };